<template>
  <div class="">  
    <div class="cc-status collapse in" id="collapseStatus">
        <div class="pull-left">
          <span  class = "text-center"></span>
        </div>
        <div class="text-right">
          <span v-show="isAcd">ACD: {{acdText}}({{login.acdKey}}) - </span>
          Callcenter: {{login.companyCallCenter.name}} - Agent:: {{login.userCallCenter.firstName}}  {{login.userCallCenter.lastName}} 
          <span class="small" :title="config_path">({{aclText}})</span>
          <button class="btn btn-default btn-xs" type="button" @click="$emit('logout')" title="logout">
            <span class="glyphicon glyphicon-log-out" aria-hidden="true"></span>
          </button>
        </div>
    </div>
  </div>

</template>



<script>

import bus from './common/bus'
import moment from 'moment'  
import * as miscConf from './common/misc.conf'

export default {
  
  data () {
    return {
      login: {},
      loggedInDiff: 0,
      calledNum: '',
      callingNum: '',
      config_path: bus.config.path,
    }

  },
  
  
  created: function () {
    //bus.registerOnLogin(this.onLogin)
    bus.registerOnIdCompanyClient(this.onIdCompanyClient)
    this.login = bus.getLoginData()
    //this.login = Object.assign({}, this.login, bus.getLoginData())

  },
  
  mounted: function () {
    

  },
  
  
  computed: {
    
    
    
    isAcd: function() {
      return !!this.login.companyCallCenter.acdTyp;
    },
    
    calledNumber: function() {
      return bus.call.calledNumber;
    },
    
    callingNumber: function() {
      return bus.call.callingNumber;
    },
    
    aclText: function() {
      // ToDo move to a config file -> i18n
      const acls = [
        { 'acl': '210',  'text': 'KD-Mitarbeiter'},
        { 'acl': '220',  'text': 'KD-Agent'},
        { 'acl': '255',  'text': 'KD-Supervisor',},
        { 'acl': '550',  'text': 'CC-Agent'},
        { 'acl': '555',  'text': 'CC-Supervisor'},
        { 'acl': '560',  'text': 'CC-Admin'},
        { 'acl': '666',  'text': 'PGM-Supervisor'},
        { 'acl': '777',  'text': 'Admin'},
      ];
      let acl = _.find(acls, ['acl', this.login.userCallCenter.acl]);
      return typeof(acl) != 'undefined' ? acl.text : '';
    },

    acdText: function() {
      // ToDo move to a config file -> i18n
      
      return miscConf.acdText(this.login.companyCallCenter.acdTyp);
    },
    
  
  },  
  
  
  
  methods: {
    
    onLogin: function (login, event, call) {
      this.login = login;
    },

    onIdCompanyClient: function (idCompanyClient, event, call) {
      if(idCompanyClient == 0){
        $('#collapseStatus').collapse('show');   
      }else{
        $('#collapseStatus').collapse('hide');
      }
    },
    
    reset: function () {
    },
    

  }

}
  
</script>



<style scoped>
  
  .cc-status{
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  

</style>



// WEBPACK FOOTER //
// Status.vue?75be08a4